import React from 'react';
import reqwest from 'reqwest';
import swal from 'sweetalert';
import sha512 from 'sha512';

import settings from '../../../settings';

import RightSide from '../../components/FormArea/RightSide';
import Loader from '../../components/Loader';
import Form from '../../components/Form';
import Button from '../../components/Button';
import Input from '../../components/Inputs/Input';
import ContentBox from '../../components/FormArea/ContentBox';
import Dropdown from '../../components/Inputs/Dropdown';
import { faTimes, faSave } from '@fortawesome/pro-solid-svg-icons';
import getConstants from '../../logic/constants';
import DataContainer from '../../logic/dataContainer';
import checkAvailable from '../../logic/checkAvailable';

class UsersNew extends React.Component {
  constructor(props) {
    super(props);

    this.parentRoute = this.props.match.url.replace(/\/new$/, '');
    this.dataContainer = new DataContainer();

    this.dataContainer.add('Basic', {
      Guid: '',
      Typ: 'Staff',
    });
    this.dataContainer.add('Login', {
      Username: '',
      Password: '',
    });
    this.dataContainer.add('Workdata', {
      Expnr: '',
      RegionalAdvisor: '',
      PersonalNr: '',
      Position: '',
      Salutation: '',
      Firstname: '',
      Lastname: '',
      BirthName: '',
      Dateofbirth: '',
      EMail: '',
      Tel: '',
      Fax: '',
      Nationality: '',
      BirthPlace: '',
    });
    this.dataContainer.add('Privatedata', {
      FamilyStatus: '',
      Telpriv: '',
      HandyP: '',
      EMailpriv: '',
      Zip: '',
      Street: '',
      City: '',
    });
    this.dataContainer.add('Additionalinfos', {
      DateOfLeaving: '',
      ExaminationDate: '',
      TrainingEnd: '',
      Ada: '',
      ImageRights: '',
      Notes: '',
    });

    this.state = {
      loading: true,
    };

    const positionPromise = getConstants('Positiontype').then(positions => {
      this.setState({
        positions,
      });
    });

    const maritalStatusPromise = getConstants('MaritalStatus').then(maritalStatus => {
      this.setState({
        maritalStatus,
      });
    });

    const rlPromise = reqwest({
      method: 'get',
      url: settings.usermanagement.general.getUserForPosition,
      data: {
        Token: localStorage.getItem('token'),
        Position: 'RL',
      },
    }).then(users => {
      users = JSON.parse(users);

      this.setState({
        users: users.map(element => {
          return {
            value: element.Params.Guid,
            label: `${element.Params.Firstname} ${element.Params.Lastname} (${element.Params.Expnr})`,
          };
        }),
      });
    });

    Promise.all([positionPromise, maritalStatusPromise, rlPromise]).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  save = async () => {
    const isValid = await this.form.validate();
    if (!isValid) {
      swal({
        title: 'Überprüfung fehlgeschlagen!',
        icon: 'error',
        text: 'Bitte überprüfen Sie Ihre Eingaben.',
      });
      return;
    }

    const newUser = this.dataContainer.getStringified();

    reqwest({
      method: 'POST',
      url: settings.usermanagement.general.save,
      data: {
        Token: localStorage.getItem('token'),
        User: newUser,
      },
    }).then(result => {
      result = JSON.parse(result);

      if (result.Params.SaveResult === 'Saved') {
        swal({
          title: 'Erfolgreich!',
          text: 'Der Nutzer wurde erfolgreich gespeichert.',
          icon: 'success',
        });
        this.props.history.replace(this.parentRoute);
      } else {
        swal({
          title: 'Fehler!',
          text: 'Es ist ein Fehler beim speichern aufgetreten.',
          icon: 'error',
        });
      }
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className='FormArea'>
          <div className='FormArea-Top'>
            <p className='FormArea-Title'>Neuen Benutzer erstellen</p>
          </div>
          <div className='FormArea-Body'>
            <div className='FormArea-Body-Content'>
              <div className='FormArea-Body-Content-Center'>
                <div className='FormArea-Form'>
                  <div className='FormArea-Form-Left'>
                    <Form ref={node => (this.form = node)}>
                      <ContentBox title='Login'>
                        <Input
                          type='text'
                          label='Nutzername:'
                          validator={[
                            {
                              required: true,
                              error: 'Bitte füllen Sie dieses Feld aus',
                            },
                            {
                              custom: async value => {
                                if (this.dataContainer.getInitial('Login', 'Username') !== value) {
                                  return await checkAvailable('username', value);
                                }
                                return true;
                              },
                              error: 'Dieser Nutzername wird bereits verwendet',
                            },
                          ]}
                          onChange={value => {
                            this.dataContainer.set('Login', 'Username')(value);
                          }}
                          defaultValue={this.dataContainer.get('Login', 'Username')}
                          name='Nutzername'
                        />

                        <Input
                          passwordValidator
                          passwordShowButton
                          type='password'
                          label='Passwort:'
                          validator={[
                            {
                              required: true,
                              error: 'Bitte füllen Sie dieses Feld aus',
                            },
                          ]}
                          onChange={value => {
                            this.dataContainer.set('Login', 'Password')(sha512(value).toString('hex'));
                          }}
                          defaultValue={this.dataContainer.get('Login', 'Password')}
                          name='Passwort'
                        />
                      </ContentBox>
                      <ContentBox title='Stammdaten'>
                        <Input
                          type='text'
                          label='Vorname:'
                          validator={[
                            {
                              required: true,
                              error: 'Bitte füllen Sie dieses Feld aus',
                            },
                          ]}
                          onChange={value => {
                            this.dataContainer.set('Workdata', 'Firstname')(value);
                          }}
                          defaultValue={this.dataContainer.get('Workdata', 'Firstname')}
                          name='Vorname'
                        />
                        <Input
                          type='text'
                          label='Nachname:'
                          validator={[
                            {
                              required: true,
                              error: 'Bitte füllen Sie dieses Feld aus',
                            },
                          ]}
                          onChange={value => {
                            this.dataContainer.set('Workdata', 'Lastname')(value);
                          }}
                          defaultValue={this.dataContainer.get('Workdata', 'Lastname')}
                          name='Nachname'
                        />
                        <Input
                          type='text'
                          label='E-Mail:'
                          validator={[
                            {
                              required: true,
                              error: 'Bitte füllen Sie dieses Feld aus',
                            },
                            {
                              type: 'email',
                              error: 'Bitte geben Sie eine valide E-Mail Adresse ein',
                            },
                            {
                              custom: async value => {
                                if (this.dataContainer.getInitial('Workdata', 'EMail') !== value) {
                                  return await checkAvailable('email', value);
                                }
                                return true;
                              },
                              error: 'Diese E-Mail Adresse wird bereits verwendet',
                            },
                          ]}
                          onChange={value => {
                            this.dataContainer.set('Workdata', 'EMail')(value);
                          }}
                          defaultValue={this.dataContainer.get('Workdata', 'EMail')}
                          name='E-Mail'
                        />
                      </ContentBox>
                      <ContentBox title='Berechtigung'>
                        <Dropdown
                          label='Position: (Rolle/Gruppe)'
                          isSearchable
                          getSelected={value => {
                            this.dataContainer.set('Workdata', 'Position')(value);
                          }}
                          defaultValue={this.dataContainer.get('Workdata', 'Position')}
                          options={this.state.positions}
                          validator={[
                            {
                              required: true,
                              error: 'Bitte füllen Sie dieses Feld aus',
                            },
                          ]}
                          name='Position'
                        />
                      </ContentBox>
                    </Form>
                  </div>
                  <RightSide>
                    <Button big icon={faTimes} to={this.parentRoute}>
                      Abbrechen
                    </Button>
                    <Button big type='primary' icon={faSave} onClick={this.save}>
                      Speichern
                    </Button>
                  </RightSide>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default UsersNew;
